import { WorkspaceInfo } from '@/Workspaces/Settings/WorkspaceInfo'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/workspace/$workspaceId/settings/info')({
  component: RouteComponent,
})

function RouteComponent() {
  return <WorkspaceInfo />
}
